module.exports = __webpack_public_path__ + "static/media/styledmenu-arrow-down.5351dfe2.svg";